"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useAnimationFrame", {
    enumerable: true,
    get: function() {
        return useAnimationFrame;
    }
});
const _canUseDOM = require("../ssr/canUseDOM");
const _useBrowserTimer = require("./useBrowserTimer");
const setAnimationFrameNoop = (callback)=>{
    callback(0);
    return 0;
};
const cancelAnimationFrameNoop = (handle)=>handle;
function useAnimationFrame() {
    const isDOM = (0, _canUseDOM.canUseDOM)();
    // TODO: figure it out a way to not call global.requestAnimationFrame and instead infer window from some context
    const setAnimationFrame = isDOM ? requestAnimationFrame : setAnimationFrameNoop;
    const clearAnimationFrame = isDOM ? cancelAnimationFrame : cancelAnimationFrameNoop;
    return (0, _useBrowserTimer.useBrowserTimer)(setAnimationFrame, clearAnimationFrame);
}
